<template>
  <div class="services-search-page">
    <div class="services-search-page__loading" v-if="loading">
      {{ $t("services.loading") }}
    </div>
    <div class="services-search-page__loading" v-else-if="is403Error">
      {{ $t("services.error403") }}
    </div>
    <template v-else>
      <ServicesHeader
        :title="$t('services.search.pageTitle')"
        :breadcrumbs="breadcrumbs"
      />
      <div class="services-search-page__inner container">
        <template v-if="services?.length">
          <Loader v-if="paginationLoading" />
          <span class="services-search-page__results-count">
            {{ $t("services.search.results", { count: pagination.total }) }}
          </span>
          <ServicesSearchResults :list="services" />
          <div class="services-search-page__paginations">
            <Pagination
              v-if="pagination.last_page > 1"
              class="events-pagination"
              :page="page"
              @change="paginate"
              :page-count="pagination.last_page"
              :total-visible="paginationPageAmount"
            />
          </div>
        </template>
        <NoDataComponent v-else :text="$t('notification.noServicesFound')" />
        <EventPopularServices
          class="services-search-page__popular-services"
          :event-id="eventId"
          full-width
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ServicesHeader from "@/components/Custom/ServicesHeader.vue";
import ServicesSearchResults from "@/components/Custom/ServicesSearchResults.vue";
import EventPopularServices from "@/components/Custom/EventPopularServices.vue";
import apiServices from "@/api/services";
import { i18n } from "@v2/shared/config";
import { NoDataComponent, Loader, Pagination } from "@v2/shared/ui/components";

export default {
  name: "ServicesSearchPage",
  components: {
    Pagination,
    NoDataComponent,
    EventPopularServices,
    Loader,
    ServicesSearchResults,
    ServicesHeader
  },
  data() {
    return {
      loading: false,
      paginationLoading: false,
      page: +this.$route.query?.page || 1,
      search: null,
      services: [],
      pagination: {},
      is403Error: false
    };
  },
  async created() {
    try {
      this.loading = true;
      this.search = this.$route.query.s || null;
      await this.getServices(this.page);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters("event", ["eventId"]),
    paginationPageAmount() {
      return window.innerWidth > 570 ? 5 : 2;
    },
    breadcrumbs() {
      return [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        },
        {
          title_rus: "Заказ услуг",
          title_eng: "Services ordering",
          route: { name: "categories", params: { id: this.$route.params.id } }
        }
      ];
    }
  },
  methods: {
    async getServices(page) {
      let data = {};
      i18n.locale === "ru"
        ? (data.name_rus = this.search)
        : (data.name_eng = this.search);
      data.page = page;
      const result = await apiServices.additionalServices(
        this.$route.params.id,
        data
      );
      this.services = result.data;
      this.pagination = result.meta;
    },
    async paginate(page) {
      try {
        this.paginationLoading = true;
        this.page = page;
        await this.getServices(page);
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);
        window.history.replaceState(null, null, url);
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.paginationLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.services-search-page {
  min-height: 100%;
  flex-grow: 1;
  background-color: var(--gray, #f9f9f9);

  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .container {
    width: 100%;

    @media (max-width: 740px) {
      width: auto;
    }
  }

  &__loading {
    margin: auto;
    padding: 20px;

    font-size: 1rem;
    font-weight: 500;
    color: var(--dark-light, #6d7179);
  }

  &__inner {
    padding: 50px 0;
    flex-grow: 1;
    @media (max-width: 440px) {
      padding: 30px 0;
    }
  }

  &__results-count {
    display: block;
    margin-bottom: 30px;
  }

  &__paginations {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__show-more {
    margin-bottom: 30px;
  }

  &__popular-services {
    margin-top: 30px;
  }
}
</style>
